export default __webpack_public_path__ + "fonts/ttf/iranyekanwebmedium.ttf";